import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './Section';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden gradient-hero pt-16 pb-20 px-4 sm:px-6 lg:px-8 min-h-[90vh] flex flex-col justify-center" data-id="element-115">
      {/* Moon Glow Backgrounds */}
      <div className="moon-glow top-[-200px] right-[-200px]" data-id="element-116"></div>
      <div className="moon-glow bottom-[-200px] left-[-200px] opacity-50" data-id="element-117"></div>

      <div className="max-w-5xl mx-auto relative z-10 w-full" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-8" data-id="element-119">
          <span className="text-accentText font-sans font-semibold tracking-[0.08em] text-sm uppercase mb-6 block" data-id="element-120">
            Librofystore™
          </span>
          <h1 className="font-serif text-[32px] leading-[1.2] md:text-5xl lg:text-6xl font-bold mb-6 text-headlineLight" data-id="element-121">
            Recuperá el control de tu cabeza antes de que el mundo se despierte.
            <br className="hidden md:block" data-id="element-122" />{' '}
            <span className="text-accentText" data-id="element-123">
              Silenciá la ansiedad nocturna y volvé a ser vos.
            </span>
          </h1>
          <p className="text-lg md:text-xl text-bodyOnDark max-w-3xl mx-auto font-normal leading-relaxed mb-10" data-id="element-124">
            Sin pastillas. Sin terapia. Sin domingos arruinados.
            <br data-id="element-125" />
            Un sistema práctico, descargable, que funciona desde esta noche.
          </p>
        </motion.div>

        {/* Product Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex justify-center mb-12" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/vATMNLvE4MBJwPjRk2D4Xv/1.webp" alt="Sueño en Paz — pack completo: 6 módulos y 5 bonos en formato libro" className="w-full max-w-2xl h-auto" data-id="element-127" />
        </motion.div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-128">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Para mujeres argentinas', '🌙 Método de 21 días', '📦 6 Módulos + 5 Bonos'].map((badge, i) => <span key={i} className="bg-[rgba(192,132,252,0.15)] border border-[rgba(192,132,252,0.4)] text-accentText px-4 py-2 rounded-full text-sm font-medium backdrop-blur-md" data-id="element-129">
              {badge}
            </span>)}
        </motion.div>

        {/* CTA Area */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.5,
        duration: 0.5
      }} className="flex flex-col items-center mb-16" data-id="element-130">
          <button onClick={scrollToPricing} className="cta-primary font-sans font-bold text-lg md:text-xl px-8 py-4 rounded-full w-full md:w-auto max-w-md flex items-center justify-center gap-2 mb-4" data-id="element-131">
            SÍ, QUIERO DORMIR EN PAZ DESDE ESTA NOCHE
          </button>
          <p className="text-xs md:text-sm text-bodyOnDark flex items-center gap-2" data-id="element-132">
            <span data-id="element-133">🛡️ Garantía 7 días</span>
            <span data-id="element-134">|</span>
            <span data-id="element-135">🔒 Pago seguro</span>
            <span data-id="element-136">|</span>
            <span data-id="element-137">💳 Mercado Pago</span>
          </p>
        </motion.div>

        {/* Social Proof Strip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7,
        duration: 0.8
      }} className="grid grid-cols-1 md:grid-cols-3 gap-4 border-y border-[rgba(232,197,245,0.2)] py-6 mb-16" data-id="element-138">
          <div className="text-center" data-id="element-139">
            <p className="font-bold text-lg text-headlineLight" data-id="element-140">+1.200</p>
            <p className="text-sm text-accentText" data-id="element-141">mujeres ya duermen mejor</p>
          </div>
          <div className="text-center border-t md:border-t-0 md:border-l border-[rgba(232,197,245,0.2)] pt-4 md:pt-0" data-id="element-142">
            <p className="font-bold text-lg text-headlineLight" data-id="element-143">6 Módulos</p>
            <p className="text-sm text-accentText" data-id="element-144">completos y prácticos</p>
          </div>
          <div className="text-center border-t md:border-t-0 md:border-l border-[rgba(232,197,245,0.2)] pt-4 md:pt-0" data-id="element-145">
            <p className="font-bold text-lg text-headlineLight" data-id="element-146">4.9/5</p>
            <p className="text-sm text-accentText" data-id="element-147">calificación ⭐⭐⭐⭐⭐</p>
          </div>
        </motion.div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-148">
          {[{
          initials: 'MG',
          text: '"La primera semana ya dormí de corrido. Algo que no me pasaba hace dos años."',
          author: 'Mariana G., Buenos Aires'
        }, {
          initials: 'LP',
          text: '"El módulo de las 3am me cambió la vida. Ya sé exactamente qué hacer y vuelvo a dormirme."',
          author: 'Laura P., Rosario'
        }, {
          initials: 'RM',
          text: '"Pensé que era ansiedad crónica. Era que nadie me había dado un sistema real."',
          author: 'Rocío M., Córdoba'
        }].map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8 + i * 0.1,
          duration: 0.5
        }} className="bg-[rgba(45,27,78,0.6)] border border-[rgba(232,197,245,0.2)] p-6 rounded-2xl backdrop-blur-[10px]" data-id="element-149">
              <div className="flex items-center gap-2 mb-3" data-id="element-150">
                <div className="w-8 h-8 rounded-full bg-bgHero flex items-center justify-center text-xs font-bold text-accentText" data-id="element-151">
                  {testimonial.initials}
                </div>
                <div className="text-goldSoft text-sm" data-id="element-152">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-sm text-bodyOnDark italic mb-4" data-id="element-153">
                "{testimonial.text}"
              </p>
              <p className="text-xs text-accentText font-semibold tracking-[0.08em] uppercase" data-id="element-154">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}